import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NgsRevealModule } from 'ngx-scrollreveal';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
// import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { CodeModule } from './code/code.module';
import { CodeRoutingModule } from './code/code-routing.module';
import { DesignModule } from './design/design.module';
import { DesignRoutingModule } from './design/design-routing.module';
import { VideoModule } from './video/video.module';
import { VideoRoutingModule } from './video/video-routing.module';

import { SharedModule } from './shared/shared.module';
import { ContentService } from './shared/content.service';



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
  ],
  imports: [
    BrowserModule,
    CodeModule,
    VideoModule,
    DesignModule,
    AppRoutingModule,
    CodeRoutingModule,
    DesignRoutingModule,
    VideoRoutingModule,
    BrowserAnimationsModule,
    NgsRevealModule,
    ScrollToModule.forRoot(),
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    // NgbModule,
    SharedModule
  ],
  providers: [ContentService],
  bootstrap: [AppComponent]
})
export class AppModule { }
export class AppBootstrapModule {}